import { useNavigate } from 'react-router-dom';
import { Container, BrandMarkWindow, BrandWatermark } from '@/components/g5';
import { AuraButton } from '@/components/aura';

interface CTABannerProps {
  heading?: string;
  subtext?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

export function CTABanner({
  heading = 'Bring your practice to Ashlar.',
  subtext = 'Join the appraisers modernizing how they work. Free during beta.',
  primaryLabel = 'Get started free',
  primaryHref = '/login?tab=signup',
  secondaryLabel = 'See features',
  secondaryHref = '/features',
}: CTABannerProps) {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28">
      <Container>
        <div
          className="relative overflow-hidden rounded-[20px] px-8 py-16 text-center md:px-16 md:py-20"
          style={{ background: 'var(--g5-accent)' }}
        >
          {/* soft inner light + the real artwork, set into the panel */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0"
            style={{ background: 'radial-gradient(80% 120% at 50% 0%, color-mix(in srgb, var(--g5-on-accent) 16%, transparent), transparent)' }}
          />
          <BrandWatermark tone="on-accent" className="absolute inset-0" />
          <BrandMarkWindow
            tone="on-accent"
            className="pointer-events-none absolute -left-14 top-1/2 hidden h-64 w-64 -translate-y-1/2 opacity-[0.1] lg:block"
          />
          <BrandMarkWindow
            tone="on-accent"
            className="pointer-events-none absolute -right-14 top-1/2 hidden h-64 w-64 -translate-y-1/2 opacity-[0.1] lg:block"
          />
          <div className="relative mx-auto max-w-2xl">
            <h2 className="font-display text-3xl font-extrabold tracking-tight md:text-[2.6rem] md:leading-tight" style={{ color: 'var(--g5-on-accent)' }}>
              {heading}
            </h2>
            <p className="mt-4 text-base leading-relaxed" style={{ color: 'color-mix(in srgb, var(--g5-on-accent) 85%, transparent)' }}>
              {subtext}
            </p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
              <AuraButton variant="inverse" onClick={() => navigate(primaryHref)}>{primaryLabel}</AuraButton>
              <AuraButton variant="ghost-inverse" onClick={() => navigate(secondaryHref)}>{secondaryLabel}</AuraButton>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
